import { FormattedMessage } from "react-intl";
import LockedByOthersIcon from "../../../components/Common/SvgIcons/SocialIcons/LockedByOthersIcon";
import LockIcon from "../../../components/Common/SvgIcons/SocialIcons/LockIcon";
import MyModerationsIcon from "../../../components/Common/SvgIcons/SocialIcons/MyModerationsIcon";
import PublishedByOthersIcon from "../../../components/Common/SvgIcons/SocialIcons/PublishedByOthersIcon";
import PublishedIcon from "../../../components/Common/SvgIcons/SocialIcons/PublishedIcon";
import RejectedIcon from "../../../components/Common/SvgIcons/SocialIcons/RejectedIcon";
import SubmissionsIcon from "../../../components/Common/SvgIcons/SocialIcons/SubmissionsIcon";
import UnlockIcon from "../../../components/Common/SvgIcons/SocialIcons/UnlockIcon";
import CopyIcon from "../../../components/Common/SvgIcons/TableIcons/CopyIcon";
import EditIcon from "../../../components/Common/SvgIcons/TableIcons/EditIcon";
import ViewIcon from "../../../components/Common/SvgIcons/TableIcons/ViewIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import {
  lockContributorShotClassActionHandler,
  unLockContributorShotClassActionHandler,
} from "../../../store/actions/actionHandlers/socialActionHandler";
import { tableColumnTypes } from "../../tableColumnTypes";
import { social } from "./social";
import { submisssions } from "./submissions";

export const moderateContributions = {
  label: "Moderate Contributions",
  path: (tenantName) => `${social.path(tenantName)}/moderateContributions`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Social Connect",
      path: `${social.path(tenantName)}`,
      onClick: () => navigate(`${social.path(tenantName)}`),
    },
    {
      key: 2,
      label: moderateContributions.label,
      path: `${moderateContributions.path(tenantName)}`,
      onClick: () =>
        navigate(`${moderateContributions.path(tenantName)}/submissions`),
    },
  ],
  tiles: (navigate, tenantName) => [
    {
      key: 1,
      label: "Submissions",
      color: "#43E57A",
      icon: (fill) => <SubmissionsIcon fill={fill} />,
      path: `${social.path(tenantName)}/moderateContributions/submissions`,
      onClick: () =>
        navigate(
          `${social.path(tenantName)}/moderateContributions/submissions`
        ),
    },
    {
      key: 2,
      label: <FormattedMessage id="MyModuration_Txt" />,
      color: "#A07EFF",
      icon: (fill) => <MyModerationsIcon fill={fill} />,
      path: `${social.path(tenantName)}/moderateContributions/myModerations`,
      onClick: () =>
        navigate(
          `${social.path(tenantName)}/moderateContributions/myModerations`
        ),
    },
    {
      key: 3,
      label: <FormattedMessage id="LockedByOthers_Txt" />,
      color: "#FF7EB5",
      icon: (fill) => <LockedByOthersIcon fill={fill} />,
      path: `${social.path(tenantName)}/moderateContributions/lockByOthers`,
      onClick: () =>
        navigate(
          `${social.path(tenantName)}/moderateContributions/lockByOthers`
        ),
    },
    {
      key: 4,
      label: <FormattedMessage id="Rejected_Txt" />,
      color: "#FB9F34",
      icon: (fill) => <RejectedIcon fill={fill} />,
      path: `${social.path(tenantName)}/moderateContributions/rejected`,
      onClick: () =>
        navigate(`${social.path(tenantName)}/moderateContributions/rejected`),
    },
    {
      key: 5,
      label: <FormattedMessage id="MYCLASS_PUBLISHED" />,
      color: "#34B7FB",
      icon: (fill) => <PublishedIcon fill={fill} />,
      path: `${social.path(tenantName)}/moderateContributions/published`,
      onClick: () =>
        navigate(`${social.path(tenantName)}/moderateContributions/published`),
    },
    {
      key: 6,
      label: <FormattedMessage id="MYCLASS_PUBLISHEDBYOTHERS" />,
      color: "#70FB34",
      icon: (fill) => <PublishedByOthersIcon fill={fill} />,
      path: `${social.path(
        tenantName
      )}/moderateContributions/publishedByOthers`,
      onClick: () =>
        navigate(
          `${social.path(tenantName)}/moderateContributions/publishedByOthers`
        ),
    },
  ],
  submissionsColumns: (
    location,
    navigate,
    dispatch,
    handleSearchQuery,
    tenantName
  ) => [
    {
      ID: 1,
      name: <FormattedMessage id="Overview_Txt" />,
      fieldName: "ContributorOverview",
      value: (row) => (
        <div title={row?.ContributorOverview}>
          {row?.ContributorOverview?.length > 25
            ? row?.ContributorOverview?.slice(0, 23) + "..."
            : row?.ContributorOverview}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="ContributorUserName_lbl" />,
      fieldName: "ContributorUserName",
      value: (row) => row.ContributorUserName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="SubmittedDate_Txt" />,
      fieldName: "CreatedDate",
      value: (row) => row.CreatedDate,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 4,
      name: <FormattedMessage id="STATUS_TEXT" />,
      fieldName: "VideoUploadStatusText",
      value: (row) => {
        switch (row.VideoUploadStatusText) {
          case "VideoNotAvailable":
            return <FormattedMessage id="VideoNotAvailable" />;
          case "ProcessingSucceed":
            return <FormattedMessage id="ProcessingSucceed" />;
          case "ProcessingInProgress":
            return <FormattedMessage id="ProcessingInProgress" />;
          default:
            break;
        }
      },
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="LastModifiedBy_lbl" />,
      fieldName: "ModeratorUserName",
      value: (row) => row.ModeratorUserName,
      type: tableColumnTypes.DATE,
      sort: true,
      hidden: location?.pathname !== submisssions?.path(tenantName),
    },
    {
      ID: 6,
      name: <FormattedMessage id="LastModifiedByDate_lbl" />,
      fieldName: "ModifiedDate",
      value: (row) => row.ModifiedDate,
      type: tableColumnTypes.DATE,
      sort: true,
    },
    {
      ID: 7,
      name: <FormattedMessage id="Cer_Actions" />,
      value: (row) => (
        <div>
          {location.pathname ===
            `${social.path(tenantName)}/moderateContributions/submissions` && (
            <div
              style={{
                display: "flex",
                gap: "1rem",
                alignItems: "center",
              }}
            >
              <span
                onClick={() => {
                  localStorage.setItem("shotclassTypeFrom", row?.StatusText);
                  navigate(
                    `${social.path(
                      tenantName
                    )}/moderateContributions/updateShotclasses/${row.ID}`
                  );
                  dispatch(lockContributorShotClassActionHandler(row.ID));
                }}
              >
                <Tooltip
                  direction="bottom"
                  content={<FormattedMessage id="P_Lock" />}
                >
                  <LockIcon />
                </Tooltip>
              </span>
              {row.VideoUploadStatusText !== "VideoNotAvailable" &&
                row.VideoUploadStatusText !== "ProcessingInProgress" && (
                  <span
                    onClick={() => {
                      localStorage.setItem(
                        "shotclassTypeFrom",
                        row?.StatusText
                      );
                      navigate(
                        `${social.path(
                          tenantName
                        )}/moderateContributions/viewShotclasses/${row.ID}`
                      );
                    }}
                  >
                    <Tooltip
                      direction="bottom"
                      content={<FormattedMessage id="View_Content_Txt" />}
                    >
                      <ViewIcon />
                    </Tooltip>
                  </span>
                )}
            </div>
          )}
          {location.pathname ===
            `${social.path(
              tenantName
            )}/moderateContributions/myModerations` && (
            <div
              style={{
                display: "flex",
                gap: "1rem",
                paddingRight: "0.5rem",
                alignItems: "center",
              }}
            >
              <span
                onClick={() => {
                  localStorage.setItem("shotclassTypeFrom", row?.StatusText);
                  navigate(
                    `${social.path(
                      tenantName
                    )}/moderateContributions/updateShotclasses/${row.ID}`
                  );
                }}
              >
                <Tooltip
                  direction="bottom"
                  content={<FormattedMessage id="MYCLASS_EDIT" />}
                >
                  <EditIcon />
                </Tooltip>
              </span>
              <span
                onClick={() => {
                  localStorage.setItem("shotclassTypeFrom", row?.StatusText);
                  dispatch(
                    unLockContributorShotClassActionHandler(
                      row.ID,
                      navigate,
                      location,
                      handleSearchQuery,
                      tenantName
                    )
                  );
                }}
              >
                <Tooltip
                  direction="bottom"
                  content={<FormattedMessage id="P_Unlock" />}
                >
                  <UnlockIcon />
                </Tooltip>
              </span>
            </div>
          )}
          {location.pathname ===
            `${social.path(tenantName)}/moderateContributions/lockByOthers` && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {row.VideoUploadStatusText !== "VideoNotAvailable" &&
                row.VideoUploadStatusText !== "ProcessingInProgress" && (
                  <span
                    onClick={() => {
                      localStorage.setItem(
                        "shotclassTypeFrom",
                        row?.StatusText
                      );
                      navigate(
                        `${social.path(
                          tenantName
                        )}/moderateContributions/viewShotclasses/${row.ID}`
                      );
                    }}
                  >
                    <Tooltip
                      direction="bottom"
                      content={<FormattedMessage id="View_Content_Txt" />}
                    >
                      <ViewIcon />
                    </Tooltip>
                  </span>
                )}
            </div>
          )}
          {location.pathname ===
            `${social.path(tenantName)}/moderateContributions/rejected` && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {row.VideoUploadStatusText !== "VideoNotAvailable" &&
                row.VideoUploadStatusText !== "ProcessingInProgress" && (
                  <span
                    onClick={() => {
                      localStorage.setItem(
                        "shotclassTypeFrom",
                        row?.StatusText
                      );
                      navigate(
                        `${social.path(
                          tenantName
                        )}/moderateContributions/viewShotclasses/${row.ID}`
                      );
                    }}
                  >
                    <Tooltip
                      direction="bottom"
                      content={<FormattedMessage id="View_Content_Txt" />}
                    >
                      <ViewIcon />
                    </Tooltip>
                  </span>
                )}
            </div>
          )}
        </div>
      ),
      fieldName: "",
      sort: false,
    },
  ],
  columns: (location, navigate, dispatch, handleSearchQuery, tenantName) => [
    {
      ID: 1,
      name: <FormattedMessage id="Overview_Txt" />,
      fieldName: "ContributorOverview",
      value: (row) => (
        <div title={row?.ContributorOverview}>
          {row?.ContributorOverview?.length > 25
            ? row?.ContributorOverview?.slice(0, 23) + "..."
            : row?.ContributorOverview}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="ContributorUserName_lbl" />,
      fieldName: "ContributorUserName",
      value: (row) => row.ContributorUserName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="SubmittedDate_Txt" />,
      fieldName: "CreatedDate",
      value: (row) => row.CreatedDate,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 4,
      name: <FormattedMessage id="STATUS_TEXT" />,
      fieldName: "VideoUploadStatusText",
      value: (row) => {
        switch (row.VideoUploadStatusText) {
          case "VideoNotAvailable":
            return <FormattedMessage id="VideoNotAvailable" />;
          case "ProcessingSucceed":
            return <FormattedMessage id="ProcessingSucceed" />;
          case "ProcessingInProgress":
            return <FormattedMessage id="ProcessingInProgress" />;
          default:
            break;
        }
      },
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="LastModifiedByDate_lbl" />,
      fieldName: "ModifiedDate",
      value: (row) => row.ModifiedDate,
      type: tableColumnTypes.DATE,
      sort: true,
    },
    {
      ID: 6,
      name: <FormattedMessage id="Cer_Actions" />,
      value: (row) => (
        <div>
          {location.pathname ===
            `${social.path(tenantName)}/moderateContributions/submissions` && (
            <div
              style={{
                display: "flex",
                gap: "1rem",
                alignItems: "center",
              }}
            >
              <span
                onClick={() => {
                  localStorage.setItem("shotclassTypeFrom", row?.StatusText);
                  navigate(
                    `${social.path(
                      tenantName
                    )}/moderateContributions/updateShotclasses/${row.ID}`
                  );
                  dispatch(lockContributorShotClassActionHandler(row.ID));
                }}
              >
                <Tooltip
                  direction="bottom"
                  content={<FormattedMessage id="P_Lock" />}
                >
                  <LockIcon />
                </Tooltip>
              </span>
              {row.VideoUploadStatusText !== "VideoNotAvailable" &&
                row.VideoUploadStatusText !== "ProcessingInProgress" && (
                  <span
                    onClick={() => {
                      localStorage.setItem(
                        "shotclassTypeFrom",
                        row?.StatusText
                      );
                      navigate(
                        `${social.path(
                          tenantName
                        )}/moderateContributions/viewShotclasses/${row.ID}`
                      );
                    }}
                  >
                    <Tooltip
                      direction="bottom"
                      content={<FormattedMessage id="View_Content_Txt" />}
                    >
                      <ViewIcon />
                    </Tooltip>
                  </span>
                )}
            </div>
          )}
          {location.pathname ===
            `${social.path(
              tenantName
            )}/moderateContributions/myModerations` && (
            <div
              style={{
                display: "flex",
                gap: "1rem",
                paddingRight: "0.5rem",
                alignItems: "center",
              }}
            >
              <span
                onClick={() => {
                  localStorage.setItem("shotclassTypeFrom", row?.StatusText);
                  navigate(
                    `${social.path(
                      tenantName
                    )}/moderateContributions/updateShotclasses/${row.ID}`
                  );
                }}
              >
                <Tooltip
                  direction="bottom"
                  content={<FormattedMessage id="MYCLASS_EDIT" />}
                >
                  <EditIcon />
                </Tooltip>
              </span>
              <span
                onClick={() => {
                  localStorage.setItem("shotclassTypeFrom", row?.StatusText);
                  dispatch(
                    unLockContributorShotClassActionHandler(
                      row.ID,
                      navigate,
                      location,
                      handleSearchQuery,
                      tenantName
                    )
                  );
                }}
              >
                <Tooltip
                  direction="bottom"
                  content={<FormattedMessage id="P_Unlock" />}
                >
                  <UnlockIcon />
                </Tooltip>
              </span>
            </div>
          )}
          {location.pathname ===
            `${social.path(tenantName)}/moderateContributions/lockByOthers` && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {row.VideoUploadStatusText !== "VideoNotAvailable" &&
                row.VideoUploadStatusText !== "ProcessingInProgress" && (
                  <span
                    onClick={() => {
                      localStorage.setItem(
                        "shotclassTypeFrom",
                        row?.StatusText
                      );
                      navigate(
                        `${social.path(
                          tenantName
                        )}/moderateContributions/viewShotclasses/${row.ID}`
                      );
                    }}
                  >
                    <Tooltip
                      direction="bottom"
                      content={<FormattedMessage id="View_Content_Txt" />}
                    >
                      <ViewIcon />
                    </Tooltip>
                  </span>
                )}
            </div>
          )}
          {location.pathname ===
            `${social.path(tenantName)}/moderateContributions/rejected` && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {row.VideoUploadStatusText !== "VideoNotAvailable" &&
                row.VideoUploadStatusText !== "ProcessingInProgress" && (
                  <span
                    onClick={() => {
                      localStorage.setItem(
                        "shotclassTypeFrom",
                        row?.StatusText
                      );
                      navigate(
                        `${social.path(
                          tenantName
                        )}/moderateContributions/viewShotclasses/${row.ID}`
                      );
                    }}
                  >
                    <Tooltip
                      direction="bottom"
                      content={<FormattedMessage id="View_Content_Txt" />}
                    >
                      <ViewIcon />
                    </Tooltip>
                  </span>
                )}
            </div>
          )}
        </div>
      ),
      fieldName: "",
      sort: false,
    },
  ],
  publishedByOtherscolumns: () => [
    {
      ID: 1,
      name: <FormattedMessage id="REPORT_CLSNAME" />,
      fieldName: "Name",
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="ContributorUserName_lbl" />,
      fieldName: "FirstName",
      value: (row) => row.FirstName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="LastModifiedByDate_lbl" />,
      fieldName: "ModifiedDate",
      value: (row) => row.ModifiedDate,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 4,
      name: <FormattedMessage id="STATUS_TEXT" />,
      fieldName: "StatusText",
      value: (row) => (row.IsDistributed ? "Distributed" : "Published"),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="MyClassVideoUploadStatus_lbl" />,
      fieldName: "VideoUploadStatusText",
      value: (row) => {
        switch (row.VideoUploadStatusText) {
          case "VideoNotAvailable":
            return <FormattedMessage id="VideoNotAvailable" />;
          case "ProcessingSucceed":
            return "Processed";
          case "ProcessingInProgress":
            return <FormattedMessage id="ProcessingInProgress" />;
          default:
            break;
        }
      },
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 6,
      name: <FormattedMessage id="MYCLASS_LANGUAGE" />,
      fieldName: "LocaleDisplay",
      value: (row) => row.LocaleDisplay,
      type: tableColumnTypes.STRING,
      sort: true,
    },
    {
      ID: 7,
      name: <FormattedMessage id="Cer_Actions" />,
      value: (row) => (
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <span>
            <CopyIcon />
          </span>
          <span>
            <ViewIcon />
          </span>
        </div>
      ),
      fieldName: "",
      sort: false,
    },
  ],
};
